import {
	GET_CONVERSATION_HISTORY,
	GET_CONVERSATION_HISTORY_SUCCESS,
	GET_CONVERSATION_HISTORY_FAIL,
	GET_CONVERSATION_HISTORY_RESET,
} from '../actions/getConversationHistoryAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getConversationHistoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CONVERSATION_HISTORY:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_CONVERSATION_HISTORY_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message || 'success',
			};
		case GET_CONVERSATION_HISTORY_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors || null,
				message: action.response.message || 'error',
			};
		case GET_CONVERSATION_HISTORY_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getConversationHistoryReducer;
